import MCallingActionButtonList from './index.vue';

MCallingActionButtonList.install = app => {
  app.component(MCallingActionButtonList.name, MCallingActionButtonList);
};

export default MCallingActionButtonList;
